var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66669 8.33337H14.8334C16.25 8.33337 17.3334 9.41671 17.3334 10.8334V16.6667C17.3334 18.0834 16.25 19.1667 14.8334 19.1667H3.16669C1.75002 19.1667 0.666687 18.0834 0.666687 16.6667V10.8334C0.666687 9.41671 1.75002 8.33337 3.16669 8.33337H4.00002V5.83337C4.00002 4.50004 4.50002 3.25004 5.50002 2.33337C6.41669 1.33337 7.66669 0.833374 9.00002 0.833374C11.3334 0.833374 13.4167 2.50004 13.9167 4.83337C14 5.33337 13.6667 5.75004 13.25 5.83337C12.8334 5.91671 12.3334 5.58337 12.25 5.16671C11.9167 3.58337 10.5834 2.50004 9.00002 2.50004C8.08335 2.50004 7.25002 2.83337 6.66669 3.50004C6.00002 4.08337 5.66669 4.91671 5.66669 5.83337V8.33337ZM14.8334 17.5C15.3334 17.5 15.6667 17.1667 15.6667 16.6667V10.8334C15.6667 10.3334 15.3334 10 14.8334 10H3.16669C2.66669 10 2.33335 10.3334 2.33335 10.8334V16.6667C2.33335 17.1667 2.66669 17.5 3.16669 17.5H14.8334Z",
    fill: "#515151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.c8a56ed487de0186d00a2737a7c30b8d.svg";
export { ForwardRef as ReactComponent };